import React, { FC, PropsWithChildren } from 'react';
import cls from 'classnames';

import styles from './index.module.sass';

interface LinkProps {
  className?: string;
  href: string;
}

const Link: FC<PropsWithChildren<LinkProps>> = ({ children, className, href }) => (
  <a className={cls( styles.link, className )} href={href}>
    {children}
  </a>
);

export default Link;
